export const toTitleCase = (value = "") => {
  const normalized = String(value || "").trim();
  if (!normalized) return "";
  return `${normalized.charAt(0).toUpperCase()}${normalized.slice(1).toLowerCase()}`;
};

export const normalizeClient = (client = {}, index = 0) => {
  const nameSlug = (client.name || `client-${index + 1}`)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ".");

  return {
    ...client,
    id: client.id || client._id || `client-${index + 1}`,
    phone: client.phone || client.phoneNumber || "N/A",
    email: client.email || `${nameSlug}@example.com`,
    status: toTitleCase(client.status),
    priority: toTitleCase(client.priority),
  };
};

export const normalizeClientList = (clients = []) => {
  if (!Array.isArray(clients)) return [];
  return clients.map((client, index) => normalizeClient(client, index));
};
